import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../../components/states';
// import { useTranslation } from 'react-i18next';
import ContentCategoryForm from '../../../../components/forms/ContentCategoryForm';
import Loader from '../../../../components/Loader';
import { useFetch } from '../../../../hooks/useFetch';

export default function ContentsCategoriesEditPage() {
  // const { t } = useTranslation();
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/categories/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <ContentCategoryForm defaultValues={data?.data} /> : <Loader />;
}
